import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUsaStats } from "./usaSlice";
import { fetchUsaStats } from "./usaSlice";
import CircularProgress from "@material-ui/core/CircularProgress";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

import AccordionActions from "@material-ui/core/AccordionActions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InsertChartIcon from "@material-ui/icons/InsertChart";

import Button from "@material-ui/core/Button";
import styles from "./usa.module.css";

function Usa() {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const dispatch = useDispatch();
  useLayoutEffect(() => {
    dispatch(fetchUsaStats());
  }, [dispatch]);
  const res = useSelector(selectUsaStats);

  if (res.error) {
    return <div>{res.error}</div>;
  }

  if (res.isLoading) {
    return (
      <div className="loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <h1>Stats for USA</h1>
      <div className={styles.accordContainer}>
        {res.usdata.map((s) => (
          <Accordion
            expanded={expanded === s.state}
            onChange={handleChange(s.state)}
            key={s.state}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className={styles.summaryContainer}>
                <div className={styles.heading}>{s.state}</div>
                <div className={styles.secondaryHeading}>
                  population:{" "}
                  {s.population === 0 ? "N/A" : s.population.toLocaleString()}
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              Cases: {s.cases.toLocaleString()} | Recovered:{" "}
              {s.recovered.toLocaleString()} | Deaths:{" "}
              {s.deaths.toLocaleString()} | Today's Cases{" "}
              {s.todayCases.toLocaleString()} | Today's Deaths{" "}
              {s.todayDeaths.toLocaleString()} | Deaths Per Million:{" "}
              {s.deathsPerOneMillion.toLocaleString()}
            </AccordionDetails>
            <AccordionActions>
              <Link
                to={"/usachart/" + s.state}
                style={{ textDecoration: "none" }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  endIcon={<InsertChartIcon />}
                >
                  Chart
                </Button>
              </Link>
            </AccordionActions>
          </Accordion>
        ))}
      </div>
    </>
  );
}

export default Usa;
